"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var assets = exports.assets = "\n  assets {\n    type\n    url\n    alt\n  }\n";